import './tab-bar.css';
import { useState } from 'react';
import { TabPanel, TabView } from 'primereact/tabview';

interface TabBarDataModel {
  tabs: string[];
  onClick: (index: number) => void;
  disable?: boolean;
}

const TabBar: React.FC<TabBarDataModel> = ({
  tabs,
  onClick,
  disable = false,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className={'tab-bar-root-column'}>
      <div className={'tab-bar-root-row'}>
        <TabView
          pt={{
            panels: { className: 'hidden' }, // Using Tailwind's hidden class
          }}
          color={'green'}
          style={{ width: '100%' }}
          className={'p-tabview'}
          activeIndex={selectedIndex}
          onTabChange={(e) => {
            onClick(e.index);
            setSelectedIndex(e.index);
          }}
        >
          {tabs.map((item, index) => (
            <TabPanel disabled={disable} key={index} header={item} on />
          ))}
        </TabView>

        {/*{tabs.map((item, index) => (
          <div
            onClick={() => {
              setSelectedIndex(index);
              onClick(index);
            }}
            className={'tab-bar-root-column'}
          >
            <div
              className={
                index === selectedIndex
                  ? 'tab-bar-item-selected'
                  : 'tab-bar-item'
              }
              key={index}
            >
              {item}
              {index === selectedIndex && (
                <div className={'tab-bar-item-under-line'}></div>
              )}
            </div>
          </div>
        ))}*/}
      </div>
      {/*<div className={'tab-bar-item-line'}></div>*/}
    </div>
  );
};

export default TabBar;
